import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import './SplashScene.scss'

export default class SplashScene extends Component {

  render () {
    return (
      <CSSTransitionGroup
        transitionName='co_splash'
        transitionEnterTimeout={1000}
        transitionLeaveTimeout={1000}
      >
        {this.props.visible &&
          <div>
            <div
              id='co_splash__logo'
              className='co_splash__logo'
              style={{ backgroundImage: `url(${this.props.logo})` }}
            />
            <div className='co_splash' key='splash'>
              <div className='co_splash__content'>
                <div id='co_splash__title' className='co_splash__title'>{ this.props.title }</div>
              </div>
            </div>
          </div>
        }
      </CSSTransitionGroup>
    )
  }

  static propTypes = {
    title: PropTypes.string,
    logo: PropTypes.string,
    visible: PropTypes.bool,
  }
}



// WEBPACK FOOTER //
// ./src/templates/coffee/components/splash/SplashScene.js